var _path, _path2, _path3, _circle, _g, _use, _path4, _use2, _use3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPhilippine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    viewBox: "-28 -45 180 90",
    fill: "#fcd116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of the Philippines") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0038a8",
    d: "m-28-45h180V0L0 44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m0 0h152v45H-28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m49.942 0L-28 45v-90z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m0 0-3.164-15.909.945-.946zl-1.169-17.831L0-19l1.169 1.169zl2.219-16.855.945.946z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90)",
    xlinkHref: "#b"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(45)",
    xlinkHref: "#c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "m40.942 0-3.382 1.176L37.487 4.755l-2.163-2.853-3.427 1.037L33.942 0l-2.045-2.939 3.427 1.037 2.163-2.853L37.56-1.176z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(120,-2.019,0)",
    xlinkHref: "#s"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(240,-2.019,0)",
    xlinkHref: "#s"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhilippine);
export default __webpack_public_path__ + "static/media/ic_philippine.85f255990d52ba02de1a1e190ada07f9.svg";
export { ForwardRef as ReactComponent };